import { render } from "./CategoryMenu.vue?vue&type=template&id=824293cc"
import script from "./CategoryMenu.vue?vue&type=script&lang=js"
export * from "./CategoryMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__